const SELECTION_LIMIT_WARNING_HEADER = 'x-selection-limit-warning';

const decodeSelectionLimitWarning = (value: string): string => {
    try {
        return decodeURIComponent(value);
    } catch {
        return value;
    }
};

const readStringHeader = (headerValue: unknown): string | null => {
    if (typeof headerValue === 'string') {
        return headerValue || null;
    }

    if (Array.isArray(headerValue) && typeof headerValue[0] === 'string') {
        return headerValue[0] || null;
    }

    return null;
};

export const extractSelectionLimitWarning = (headers: Record<string, unknown>): string | null => {
    const rawValue = readStringHeader(headers[SELECTION_LIMIT_WARNING_HEADER]);
    return rawValue ? decodeSelectionLimitWarning(rawValue) : null;
};

export const extractFileNameFromDisposition = (
    contentDisposition: string | null | undefined,
    fallbackFileName: string,
): string => {
    if (!contentDisposition) {
        return fallbackFileName;
    }

    const utf8Match = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i);
    if (utf8Match?.[1]) {
        try {
            return decodeURIComponent(utf8Match[1]);
        } catch {
            return utf8Match[1];
        }
    }

    const simpleMatch = contentDisposition.match(/filename=\"?([^\";]+)\"?/i);
    return simpleMatch?.[1] || fallbackFileName;
};

export const extractFileNameFromHeaders = (headers: Record<string, unknown>, fallbackFileName: string): string => {
    const contentDisposition = readStringHeader(headers['content-disposition']);
    return extractFileNameFromDisposition(contentDisposition, fallbackFileName);
};

export const triggerBlobDownload = (blob: Blob, headers: Record<string, unknown>, fallbackFileName: string): void => {
    const filename = extractFileNameFromHeaders(headers, fallbackFileName);
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');

    link.href = url;
    link.setAttribute('download', filename);
    link.click();

    window.URL.revokeObjectURL(url);
};
